import classnames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

// tslint:disable-next-line:no-var-requires
const styles = require("./CashOutLabel.scss");

export interface CashOutLabelProps {
    label: string | number;
    className?: string;
}

export function CashOutLabel(props: CashOutLabelProps) {
    if (!props.label && props.label !== 0) {
        return null;
    }
    const { t } = useTranslation("cashout");
    return (
        <div className={classnames(props.className, styles.wrapper)}>
            <div>
                <span className={classnames(styles.betslipLabel)}>
                    {t("BetNumber")} {props.label}
                </span>
            </div>
            <div>
                <span className={classnames(styles.cashoutGrowthLabel)}>
                    {t("GrowthOfCashoutValue")}
                </span>
            </div>
        </div>
    );
}
